<div class="contact-dialog">

  <ng-container *ngIf="isSent">
    <div class="success-screen">
      <i class="material-icons success-icon">mark_email_read</i>
      <h3>Request sent</h3>
      <p>
        We’ll get back to you shortly at
        <strong>{{ data.email || supportEmail }}</strong>.
      </p>
      <div class="success-actions">
        <button class="btn-send" type="button" (click)="onClose()">Done</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isError">
    <div class="error-screen">
      <i class="material-icons error-icon">mail_outline</i>
      <h3>Email not sent</h3>
      <p>Failed to send your request. Please try again.</p>
      <div class="success-actions">
        <button class="btn-cancel" type="button" (click)="onClose()">Cancel</button>
        <button class="btn-send" type="button" (click)="onRetry()">Try Again</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isSent && !isError">
    <h2 class="dialog-title">Contact Us</h2>

    <mat-dialog-content>
      <form [formGroup]="contactForm">
        <div class="field-group">
          <label>Email</label>
          <div class="input-wrapper">
            <input
              class="field-input"
              formControlName="email"
              type="email"
              readonly>
          </div>
        </div>
        <div class="field-group">
          <label>Description <span class="required-star">*</span></label>
          <div class="input-wrapper">
            <textarea
              class="field-input field-textarea"
              [class.input-error]="contactForm.get('description')?.invalid && contactForm.get('description')?.touched"
              [class.input-success]="contactForm.get('description')?.valid && contactForm.get('description')?.touched"
              formControlName="description"
              rows="4"
              placeholder="Tell us how we can help"
              (blur)="contactForm.get('description')?.markAsTouched()"></textarea>
          </div>
          <div class="error-block"
            *ngIf="contactForm.get('description')?.touched && contactForm.get('description')?.invalid">
            <div class="field-error" *ngIf="contactForm.get('description')?.hasError('required')">
              <span>Description is required</span>
            </div>
            <div class="field-error" *ngIf="contactForm.get('description')?.hasError('minlength')">
              <span>Please enter a short description of your request</span>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>

    <div class="dialog-actions">
      <button class="btn-cancel" type="button" (click)="onClose()">Cancel</button>
      <button class="btn-send" type="button" [disabled]="isLoading" (click)="onSend()">
        <span class="btn-content">
          <span class="loader" *ngIf="isLoading"></span>
          Send
        </span>
      </button>
    </div>
  </ng-container>

</div>
